import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';
import { isErrorResponse } from '@bulknutrients/bulk-shared-lib/interfaces/BulkAPI';
import { useSWRConfig } from 'swr';

export function useRemoveItem() {
  const { mutate } = useSWRConfig();

  return async ({
    itemId,
    wishlistId,
  }: {
    itemId: number;
    wishlistId: number;
  }): Promise<{
    data: null;
    error: string | null;
  }> => {
    const res = await fetch('/api/wishlist', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        itemId,
        wishlistId,
      }),
    }).then((res) => res.json());

    // Can we be more useful with error message
    if (isErrorResponse(res)) {
      return {
        data: null,
        error: res.error.message.join('. '),
      };
    }

    mutate(SWR_KEYS.wishlist);

    return {
      data: res.data,
      error: null,
    };
  };
}
